import { BusinessSchema } from '@40seas/entities/businesses';
import { Buyer } from '@40seas/entities/buyers';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export enum AirwallexIntentStatus {
    RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
    RequiresCapture = 'REQUIRES_CAPTURE',
    RequiresCustomerAction = 'REQUIRES_CUSTOMER_ACTION',
    Pending = 'PENDING',
    Succeeded = 'SUCCEEDED',
    Cancelled = 'CANCELLED',
}

export const AirwallexIntentSchema = WithBaseEntitySchema(
    z.object({
        buyer: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .or(BusinessSchema),
        providerId: z.string(),
        checkout: z.string(),
        airwallexCustomer: z.string(),
        paymentMethod: z.string().optional(),
        amount: z.number(),
        currency: EnumSchema(Currency),
        status: EnumSchema(AirwallexIntentStatus),
    }),
).strict();

export class AirwallexIntent extends FromSchema(AirwallexIntentSchema) implements BaseEntity {
    id: string;
    buyer: string | Buyer;
    providerId: string;
    checkout: string;
    airwallexCustomer: string;
    paymentMethod?: string;
    amount: number;
    currency: Currency;
    status: AirwallexIntentStatus;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
